import { render } from "./CompanyInformationLoader.vue?vue&type=template&id=0f047d23&scoped=true"
const script = {}

import "./CompanyInformationLoader.vue?vue&type=style&index=0&id=0f047d23&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f047d23"]])

export default __exports__